import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const EditInvoiceDialog = ({ editFor, onClose, editDueDate, setEditDueDate, editTerms, setEditTerms, editNotes, setEditNotes, busy, onSubmit }) => (
  <Dialog open={!!editFor} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="edit-invoice-dialog">
      <DialogHeader><DialogTitle>Edit Invoice — {editFor?.invoice_no}</DialogTitle></DialogHeader>
      <p className="text-xs text-muted-foreground -mt-2">Line items on an issued invoice can&apos;t be edited directly — use a Credit Note for returns/corrections.</p>
      <div className="space-y-3">
        <div><Label>Due Date</Label><Input data-testid="edit-invoice-due-date" type="date" value={editDueDate} onChange={(e) => setEditDueDate(e.target.value)} className="mt-1" /></div>
        <div><Label>Payment Terms (days)</Label><Input data-testid="edit-invoice-terms" type="number" value={editTerms} onChange={(e) => setEditTerms(e.target.value)} className="mt-1 font-mono" /></div>
        <div><Label>Invoice Notes</Label><Textarea data-testid="edit-invoice-notes" value={editNotes} onChange={(e) => setEditNotes(e.target.value)} rows={3} /></div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>Cancel</Button>
        <Button data-testid="edit-invoice-submit" disabled={busy} onClick={onSubmit}>Save Changes</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
